import React, { useEffect, useState } from "react";
import { Card, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow, Chip } from "@material-ui/core";
import { Button, IconButton, InputBase, Paper, Dialog, DialogActions, DialogContent, DialogTitle, useMediaQuery, Divider, Box, TextField, FormHelperText } from "@mui/material";
import { styled } from '@mui/material/styles';
import { useQuery } from 'react-query';
import { EVENTS } from "src/api/axios";
import UserListHead from "src/components/user/UserListHead";
import useAxiosPrivate from "src/hooks/useAxiosPrivate";
import Stack from '@mui/material/Stack';
import { useSnackbar } from "notistack";
import { useTheme } from '@mui/material/styles';
import SearchIcon from "src/svgComponents/SearchIcon";
import LoadingScreen from "src/components/LoadingScreen";
import moment from "moment";
import AppTooltip from "src/components/common/AppTooltip";
import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import { Form, FormikProvider, useFormik } from "formik";
import { LoadingButton } from '@mui/lab';
import { useMutation } from "react-query";
import CloseIcon from '@mui/icons-material/Close';
import ShowImage from "../common/ShowImage";


const _ = require('lodash');

const BookedTicket = () => {
    const [tableData, setTableData] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [order, setOrder] = useState('desc');
    const [orderBy, setOrderBy] = useState('createdAt');
    const axiosPrivate = useAxiosPrivate();
    const [filterName, setFilterName] = useState('');
    const { enqueueSnackbar } = useSnackbar();
    const [deleteId, setdeleteId] = useState("");
    const [open, setOpen] = useState(false);
    const theme = useTheme();
    const [loding, setLoding] = useState(true);
    const [modelTitle, setmodelTitle] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [buttonLoading, setButtonLoding] = useState(false);
    const [openPickupDialog, setIsOpenPickupDialog] = useState(false);
    const [disable, setDisable] = useState(false);
    const [flag, setFlag] = useState();
    const [tickets, setNoOfPeople] = useState("");
    const [Id, setId] = useState("");
    const [profilePic, setProfilePic] = useState("");
    const [imageName, setImageName] = useState([]);
    const [showImage, setShowImage] = useState("");
    const [totalConfirmedPayout, setTotalConfirmedPayout] = useState();
    const [uploadedImage, setUploadedImage] = useState();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const StyledTableRow = styled(TableRow)(({ theme }) => ({
        '&:nth-of-type(odd)': {
            backgroundColor: '#ffffff',
        },
        '&:nth-of-type(even)': {
            background: "linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)), #F4F5F7",
        },
        // hide last border
        '& td, & th': {
            border: 0,
        },
    }));

    const TABLE_HEAD = [
        { id: 'userName', label: 'Username', alignRight: false },
        { id: 'email', label: 'Email', alignRight: false },
        { id: 'no_of_people', label: 'Total tickets', alignRight: false },
        { id: 'price', label: 'Paid amount', alignRight: false },
        { id: 'booking_date', label: 'Booking Date', alignRight: false },
        { id: 'name', label: 'Event name', alignRight: false },
        { id: 'image', label: 'Image', alignRight: false },
        { id: 'time', label: 'Time', alignRight: false },
        { id: 'city', label: 'City', alignRight: false },
        { id: 'action', label: 'Action', alignRight: false },
    ];

    async function getbookedList(page, filterName) {
        const response = await axiosPrivate.get(EVENTS.getbookedList, { params: { page: page + 1, search: filterName, status: 0, limit: rowsPerPage } })
        return response.data[0];
    }

    const { data: bookedEventList, refetch } = useQuery(['bookedEventList', page, filterName], () => getbookedList(page, filterName), { keepPreviousData: true, })

    useEffect(() => {
        if (bookedEventList) {
            setTableData(bookedEventList.data);
            setRowsPerPage(bookedEventList?.metadata.length != 0 ? bookedEventList?.metadata[0].limit : 10);
        }
        if (bookedEventList?.metadata.length != 0 && bookedEventList?.metadata[0].hasMoreData == true) {
            getbookedList(page + 1);
        }
        setLoding(false);
    }, [bookedEventList])

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        setTimeout(() => {
            refetch();
        }, 500);
    };
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleFilterByName = (event) => {
        setFilterName(event.target.value.trim());
        setPage(0);
        getbookedList(page, filterName)
        refetch();
    };

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] < a[orderBy]) {
            return -1;
        }
        if (b[orderBy] > a[orderBy]) {
            return 1;
        }
        return 0;
    }

    const handleClosePickUpOrder = () => {
        setIsOpenPickupDialog(!openPickupDialog)
        resetForm();
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }
    function applySortFilter(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });

        return stabilizedThis.map((el) => el[0]);
    }

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const filteredUsers = applySortFilter(tableData, getComparator(order, orderBy));

    const handleClose = () => {
        setOpen(false);
    };
    const formik = useFormik({
        initialValues: {
            id: '',
            ticket_: []
        },
        onSubmit: async (values, { resetForm, setFieldError, setSubmitting }) => {

            if (values.ticket_.length < tickets) {
                enqueueSnackbar("Pleasee enter seat number", {
                    variant: "error",
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                    autoHideDuration: 2000,
                });
            } else {
                const uniqueArray = Array.from(new Set(values.ticket_));
                if (uniqueArray.length != tickets) {
                    enqueueSnackbar("Ticket number must be unique ", {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                        autoHideDuration: 2000,
                    });
                } else {
                    let ticketss = values.ticket_;
                    let ticket = [];
                    let data1 = {};
                    ticketss.map((value, key) => {
                        data1 = {
                            ticket_number: value,
                            image: null
                        }
                        if (Object.keys(imageName).length > 0) {
                            Object.keys(imageName).forEach((key1) => {
                                if (key == key1 && imageName) {
                                    data1.image = imageName[key1];
                                }
                            })
                        }
                        ticket.push(data1);
                    })
                    const informationObj = {
                        id: Id,
                        tickets: ticket
                    };
                    await confirmTicket(informationObj);
                    resetForm();
                }
            }
        },
    });

    const { mutateAsync: confirmTicket } = useMutation(
        async (data) => {
            return await axiosPrivate.post(EVENTS.sendTicket, data)
        },
        {
            onSuccess: ({ data }) => {
                enqueueSnackbar(data.message, {
                    variant: "success",
                    anchorOrigin: { vertical: "top", horizontal: "right" },
                    autoHideDuration: 2000,
                });
                handleCloseModal();
                refetch();
                setButtonLoding(false);
            },
            onError: (error) => {
                setButtonLoding(false);
                const errorData = error?.response?.data?.errors;
                if (errorData) {
                    Object.keys(errorData).forEach((key) => {
                        enqueueSnackbar("Ticket number must be of 6 characters", {
                            variant: "error",
                            anchorOrigin: { vertical: "top", horizontal: "right" },
                            autoHideDuration: 2000,
                        });
                    })
                } else {
                    enqueueSnackbar(error.response.data.message, {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                        autoHideDuration: 2000,
                    });
                }

                Object.keys(errorData).forEach((key) => {
                    if (key === "name") {
                        setFieldError("name", errorData[key]);
                    }
                    else {
                        setFieldError(key, errorData[key]);
                    }
                });
            },
        }
    );

    const { errors, touched, setFieldValue, handleSubmit, setFieldError, getFieldProps, resetForm } = formik;

    const handleCompleteOrder = (row) => {
        setmodelTitle('Ticket Detail');
        setNoOfPeople(row.no_of_people)
        setId(row._id)
        setFieldValue("image", '')
        setDisable(false);
        setProfilePic('');
        setImageName([]);
        setShowImage('');
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        resetForm();
    };

    // const handleUploadImage = async () => {
    //     const formData = new FormData();
    //     formData.append('image', uploadedImage)
    //     const imageData = await axiosPrivate
    //         .post(EVENTS.uploadImage, formData)
    //         .catch((e) => {
    //             setButtonLoding(false);
    //             enqueueSnackbar(e?.response?.data?.message, {
    //                 variant: "error",
    //                 anchorOrigin: { vertical: "top", horizontal: "right" },
    //                 autoHideDuration: 2000,
    //             });
    //         });
    //     setImageName(imageData?.data?.file_name)
    //     setFieldValue("image", imageData?.data?.file_name)
    //     return imageData?.data?.file_name;
    // }
    // { console.log(imageName); }

    // const removeImage = () => {
    //     setProfilePic('');
    //     setImageName([]);
    //     setShowImage('');
    // }
    const handleProfilePicOnChange = async (ev, index) => {
        const formData = new FormData();
        if (ev.type.includes("image")) {
            formData.append('image', ev)
            const imageData = await axiosPrivate
                .post(EVENTS.uploadticketImage, formData)
                .catch((e) => {
                    setButtonLoding(false);
                    enqueueSnackbar(e?.response?.data?.message, {
                        variant: "error",
                        anchorOrigin: { vertical: "top", horizontal: "right" },
                        autoHideDuration: 2000,
                    });
                });
            setImageName(preState => ({ ...imageName, [index]: imageData?.data?.file_name }));
            console.log(imageName)
            // setFieldValue("image", imageData?.data?.file_name)
            return imageData?.data?.file_name;
        } else {
            enqueueSnackbar("Please select only jpeg, jpg, png, webp file", {
                variant: "error",
                anchorOrigin: { vertical: "top", horizontal: "right" },
                autoHideDuration: 2000,
            });
        }
    };
    return (
        <Box>
            {loding ? <LoadingScreen /> : <>
                <div className="dashboard_header mb-4">
                    <h4 className="app_text_20_semibold mb-0 d-flex align-items-center">Pending Tickets List</h4>
                    <Paper component="form" className='dashboard_searchbox col-lg-4'>
                        <IconButton>
                            <SearchIcon />
                        </IconButton>
                        <InputBase
                            fullWidth
                            sx={{ flex: 1 }}
                            placeholder="search ..."
                            onChange={(e) => handleFilterByName(e)}
                            onKeyPress={(e) => { e.key === 'Enter' && e.preventDefault(); }}
                        />
                    </Paper>
                </div>
                <Card>
                    <TableContainer>
                        <Table>
                            <UserListHead
                                headLabel={TABLE_HEAD}
                                rowCount={bookedEventList?.data?.length}
                                onRequestSort={handleRequestSort}
                            />
                            {filteredUsers?.length > 0 ?
                                <TableBody>
                                    {filteredUsers.map((row) => {
                                        return (
                                            <StyledTableRow key={row._id}>
                                                <TableCell align="left"> {row?.userName ?? '-'} </TableCell>
                                                <TableCell align="left"> {row?.email ?? '-'} </TableCell>
                                                <TableCell align="left"> {row?.no_of_people ?? 1} </TableCell>
                                                <TableCell align="left"> £{row?.amount?.toFixed(2) ?? '-'} </TableCell>
                                                <TableCell align="left"> {moment(row.createdAt).format("DD MMM YYYY h:mm A")}</TableCell>
                                                <TableCell align="left"> {row?.name} </TableCell>
                                                <TableCell component="th" scope="row">
                                                    <img src={process.env.REACT_APP_PROFILE_URL + 'eventImage/' + row.image} height="50px" alt="profile" />
                                                </TableCell>
                                                <TableCell align="left"> {moment(row.time).format("DD MMM YYYY h:mm A")} </TableCell>
                                                <TableCell align="left"> {row?.city ?? '-'} </TableCell>
                                                <TableCell>
                                                    <Stack direction="row" sx={{ backgroundColor: '#0000001a', borderRadius: 25, p: 0.4 }} spacing={0.5} divider={<Divider orientation="vertical" flexItem />}>
                                                        <Box>
                                                            <AppTooltip title="Send Tickets" placement="bottom">
                                                                <IconButton sx={{ width: 32, height: 32, p: 2, minWidth: 'unset' }} onClick={() => handleCompleteOrder(row)}>
                                                                    <IosShareRoundedIcon />
                                                                </IconButton>
                                                            </AppTooltip>
                                                        </Box>
                                                    </Stack>
                                                </TableCell>
                                            </StyledTableRow>
                                        )
                                    })}
                                </TableBody>
                                :
                                <TableBody>
                                    <TableRow>
                                        <TableCell align="center" colSpan={9} sx={{ py: 5 }}>
                                            <span className="app_text_16_semibold">No Data Found</span>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>}
                        </Table>
                    </TableContainer>
                    <TablePagination
                        component="div"
                        rowsPerPageOptions={[10, 20, 50, 100]}
                        count={bookedEventList?.metadata.length != 0 ? bookedEventList?.metadata[0].total : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </>
            }
            {/* <Dialog
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title" className='m-auto'>
                    {"are you sure you want to delete?"}
                </DialogTitle>
                <DialogContent>
                </DialogContent>
                <DialogActions className='m-auto'>
                    <Button className="theme_button_view" variant="contained" autoFocus onClick={handleClose}>
                        cancel
                    </Button>
                    <Button className="theme_button" variant="contained" onClick={() => deleteOrder()} autoFocus>
                        delete
                    </Button>
                </DialogActions>
            </Dialog> */}
            <Dialog
                open={openModal}
                onClose={handleCloseModal}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
                fullWidth
                maxWidth="md"
            >
                <DialogTitle>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                        <h4>{modelTitle}</h4>
                        <Button className="dashboard_light_bg_icon_btn" onClick={handleCloseModal} aria-label="delete">
                            <CloseIcon style={{ color: '#fff' }} />
                        </Button>
                    </Box>
                </DialogTitle>
                <DialogContent className="custom_form_mui pt-2">
                    <FormikProvider value={formik}>
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <div className="row">

                                {[...Array(tickets)].map((ticket, index) => (
                                    <>
                                        <div className="col-lg-6">
                                            <div className="form-group mb-3" key={index}>
                                                <TextField
                                                    label={`ticket`}
                                                    name={`ticket_[${index}]`}
                                                    autoComplete='off'
                                                    fullWidth
                                                    variant='outlined'
                                                    // value={(e) => onChangeTicketNumber(e)}
                                                    {...getFieldProps(`ticket_[${index}]`)}
                                                    error={Boolean(touched.ticket_number && errors.ticket_number)}
                                                    helperText={touched.ticket_number && errors.ticket_number}
                                                />

                                                {/* <Button
                                                className="my-4 text-white app_bg_primary app_text_14_500 p-2"
                                                variant="contained"
                                                component="label"
                                                style={{ "borderRadius": 5 }}
                                            > */}

                                                {/* </Button> */}
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="form-group mb-3" key={index}>
                                                {/* <Button
                                                className="my-4 text-white app_bg_primary app_text_14_500 p-2"
                                                variant="contained"
                                                component="label"
                                                style={{ "borderRadius": 5 }}
                                            > */}
                                                {/*                                                
                                                <input
                                                   
                                                    accept="image/*"
                                                    onChange={(event) => {
                                                        const files = event.target.files[0];
                                                        if (files !== undefined) {
                                                            setFlag('asd')
                                                            handleProfilePicOnChange(files, index);
                                                        }
                                                    }}
                                                    type="file"
                                                /> */}
                                                {/* </Button> */}
                                                <input class="form-control form-control-lg h-auto" type="file"
                                                    onChange={(event) => {
                                                        const files = event.target.files[0];
                                                        if (files !== undefined) {
                                                            setFlag('asd')
                                                            handleProfilePicOnChange(files, index);
                                                        }
                                                    }} id="formFile"></input>
                                            </div>
                                        </div>
                                    </>
                                ))}

                            </div>
                            <div className="col">
                                <div className="col-md-8 m-auto">
                                    <LoadingButton
                                        type='submit'
                                        fullWidth
                                        className="my-3 text-lowercase text-white app_bg_primary app_text_16_semibold app_btn_lg"
                                        loading={buttonLoading}
                                        loadingPosition="end"
                                        variant="contained"
                                    >
                                        submit
                                    </LoadingButton>
                                </div>
                            </div>
                        </Form>
                    </FormikProvider>
                </DialogContent>
            </Dialog>
        </Box>
    )
}

export default BookedTicket